import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Col, Form, FormGroup, Input, Row } from 'reactstrap';
import TextField from '../../../../../common/TextField';
import Dropdown from '../../../../../common/DropDown';
import DatePicker from '../../../../../common/DatePicker';
import { Continue, Previous } from '../../../../../../Utils/Constants';
import { Btn, H3, H4, H5 } from '../../../../../../AbstractElements';
import { Client2Errors, Client2FormData } from '../../../FormData';
import DollarInput from '../../../../../common/DollarInput';
import { useMutationRequestQuery } from '../../../../../../Hooks/useMutationRequestQuery';
import { insertUpdateClientService } from '../../../../../../Services/PublicPageServices';
import { setFormStatus } from '../../../../../../ReduxToolkit/Reducers/FromStatusSlice';
import { useDispatch } from 'react-redux';
import MobileField from '../../../../../common/MobileField';
import { setFormsData } from '../../../../../../ReduxToolkit/Reducers/FormDataSlice';
import { updateFormData } from '../../../../../../ReduxToolkit/Reducers/FactFindDataSlice';
export default function Client2Form({ activeCallBack, clientFactFindData, clientId, setClientId, client1formData }: any) {
    const [formData, setFormData] = useState<any>(Client2FormData);
    const [formErrors, setFormErrors] = useState(Client2Errors);
    const [isChecked, setIsChecked] = useState(false);

    const validateFirstName = (value: string) => value.length >= 3;
    const validateLastName = (value: string) => value.length >= 3;
    const validateMobile = (value: string) => value !== "";
    const validateEmail = (value: string) =>
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
    const validateGender = (value: string) => value !== "";
    const validateDob = (value: Date | null) => value !== null;
    const validateDropdown = (value: string) => value !== "";
    const validateTextField = (value: string) => value.trim() !== "";
    const validateDollarInput = (value: number | null) => value !== null;
    const validateDate = (value: Date | null) => value !== null;
    const dispatch = useDispatch();

    const { mutate: insertUpdateClient, isPending: isInsertUpdateClientPending } = useMutationRequestQuery(
        'insertUpdateClientService1',
        insertUpdateClientService,
        {
            onSuccess: (data: any) => {
                toast.success("Client information submitted successfully.");
                setClientId(data?.data?.generatedClientID)
                dispatch(setFormStatus({ id: '2', status: 2 }));
                // setFormErrors(Client2Errors)
                activeCallBack(3);
            },
            onError: (error: any) => {
                toast.error("Failed to submit client information.");
                console.error(error);
            },
        }
    );
    useEffect(() => {
        dispatch(setFormsData({
            id: '2',
            formData: formData,
        }));
    }, [formData])
    const formatClient2Data = (formData: any) => {
        return {
            clientID: clientId,
            Client1Email: client1formData.email,
            Client1Mobile: client1formData.mobile,
            Client1FirstName: client1formData.firstName,
            Client1LastName: client1formData.lastName,
            client1DateOfBirth: client1formData.dob,
            client1Gender: client1formData.gender,
            clientSurnName: formData.client2FirstName,
            dateUpdated: "2025-01-14T04:56:17.173Z", // This should be dynamically set based on your requirement

            // Personal details
            client2FirstName: formData.client2FirstName,
            client2LastName: formData.client2LastName,
            client2Email: formData.client2Email,
            client2Mobile: formData.client2Mobile,
            client2DateOfBirth: formData.client2Dob,  // Assuming it's in the correct format already
            client2Gender: formData.client2Gender,
            client2ResidentStatus: formData.client2ResidentStatus,
            client2MaritalStatus: formData.client2MaritalStatus,
            client2CreditStatus: formData.client2CreditStatus,
            client2HomeStatus: formData.client2HomeStatus,

            // Address history (3 years)
            client2Address1: formData.client2Address1,
            client2Address2: formData.client2Address2,
            client2Address3: formData.client2Address3,
            client2Address1StartDate: formData.client2StartDate1,
            client2Address2StartDate: formData.client2StartDate2,
            client2Address3StartDate: formData.client2StartDate3,

            // Income details
            client2EmploymentSalaryWagesDLL: formData.client2SalaryWages,
            client2IncomeSalaryWages: formData.client2SalaryWagesIncome,
            client2IncomeSalaryFrequency: formData.client2SalaryWagesFrequency,
            client2FamilyAllowance: formData.client2FamilyAllowance,
            client2FamilyAllowanceFrequency: formData.client2FamilyAllowanceFrequency,
            client2DividendIncome: formData.client2DividendIncome,
            client2DividendIncomeFrequency: formData.client2DividendIncomeFrequency,
            client2CompanyNetProfit: formData.client2CompanyNetProfit,
            client2CompanyNetProfitFrequency: formData.client2CompanyNetProfitFrequency,

            // Employment history (3 records)
            client2CompanyName1: formData.client2Employment1CompanyName,
            client2Role1: formData.client2Employment1Role,
            client2StartDate1: formData.client2Employment1StartDate,
            client2CompanyName2: formData.client2Employment2CompanyName,
            client2Role2: formData.client2Employment2Role,
            client2StartDate2: formData.client2Employment2StartDate,
            client2CompanyName3: formData.client2Employment3CompanyName,
            client2Role3: formData.client2Employment3Role,
            client2StartDate3: formData.client2Employment3StartDate,
        };
    };


    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        // If isChecked is true, skip validation and directly proceed with submitting the data
        if (isChecked) {
            const formattedData = {
                clientID: clientId,
                Client1Email: client1formData.email,
                Client1Mobile: client1formData.mobile,
                Client1FirstName: client1formData.firstName,
                Client1LastName: client1formData.lastName,
                client1DateOfBirth: client1formData.dob,
                client1Gender: client1formData.gender,
                ClientSurnName: client1formData.firstName,
                dateUpdated: "2025-01-14T04:56:17.173Z", // Make sure to update dynamically if necessary
            };
            if (clientId != 0) {
                insertUpdateClient(formattedData);
            }
            return;
        }

        // Validate each field only if isChecked is false
        const firstNameValid = validateFirstName(formData.client2FirstName);
        const lastNameValid = validateLastName(formData.client2LastName);
        const mobileValid = validateMobile(formData.client2Mobile);
        const emailValid = validateEmail(formData.client2Email);
        const dobValid = validateDob(formData.client2Dob);
        const genderValid = validateGender(formData.client2Gender);
        const maritalStatusValid = validateDropdown(formData.client2MaritalStatus);
        const residentStatusValid = validateDropdown(formData.client2ResidentStatus);
        const creditStatusValid = validateDropdown(formData.client2CreditStatus);
        const homeStatusValid = validateDropdown(formData.client2HomeStatus);

        // Validate Address and Employment Details
        const address1Valid = validateTextField(formData.client2Address1);
        const startDate1Valid = validateDate(formData.client2StartDate1);

        // Optional fields check - validate only if not empty
        const address2Valid = formData.client2Address2 ? validateTextField(formData.client2Address2) : true;
        const startDate2Valid = formData.client2StartDate2 ? validateDate(formData.client2StartDate2) : true;

        const address3Valid = formData.client2Address3 ? validateTextField(formData.client2Address3) : true;
        const startDate3Valid = formData.client2StartDate3 ? validateDate(formData.client2StartDate3) : true;

        // Validate Income Fields
        const salaryWagesValid = validateDropdown(formData.client2SalaryWages);
        const salaryWagesIncomeValid = validateDollarInput(formData.client2SalaryWagesIncome);

        // Validate frequency only if corresponding income is not "0"
        const salaryWagesFrequencyValid = formData.client2SalaryWagesIncome !== '0' ? validateDropdown(formData.client2SalaryWagesFrequency) : true;

        const familyAllowanceValid = validateDollarInput(formData.client2FamilyAllowance);
        const familyAllowanceFrequencyValid = formData.client2FamilyAllowance !== '0' ? validateDropdown(formData.client2FamilyAllowanceFrequency) : true;

        const dividendIncomeValid = validateDollarInput(formData.client2DividendIncome);
        const dividendIncomeFrequencyValid = formData.client2DividendIncome !== '0' ? validateDropdown(formData.client2DividendIncomeFrequency) : true;

        const companyNetProfitValid = validateDollarInput(formData.client2CompanyNetProfit);
        const companyNetProfitFrequencyValid = formData.client2CompanyNetProfit !== '0' ? validateDropdown(formData.client2CompanyNetProfitFrequency) : true;

        // Validate Employment History
        const employment1CompanyNameValid = formData.client2Employment1CompanyName ? validateTextField(formData.client2Employment1CompanyName) : true;
        const employment1RoleValid = formData.client2Employment1Role ? validateTextField(formData.client2Employment1Role) : true;
        const employment1StartDateValid = formData.client2Employment1StartDate ? validateDate(formData.client2Employment1StartDate) : true;

        const employment2CompanyNameValid = formData.client2Employment2CompanyName ? validateTextField(formData.client2Employment2CompanyName) : true;
        const employment2RoleValid = formData.client2Employment2Role ? validateTextField(formData.client2Employment2Role) : true;
        const employment2StartDateValid = formData.client2Employment2StartDate ? validateDate(formData.client2Employment2StartDate) : true;

        const employment3CompanyNameValid = formData.client2Employment3CompanyName ? validateTextField(formData.client2Employment3CompanyName) : true;
        const employment3RoleValid = formData.client2Employment3Role ? validateTextField(formData.client2Employment3Role) : true;
        const employment3StartDateValid = formData.client2Employment3StartDate ? validateDate(formData.client2Employment3StartDate) : true;


        // Set errors for each field if validation fails
        setFormErrors({
            client2FirstName: !firstNameValid,
            client2LastName: !lastNameValid,
            client2Mobile: !mobileValid,
            client2Email: !emailValid,
            client2Dob: !dobValid,
            client2Gender: !genderValid,
            client2MaritalStatus: !maritalStatusValid,
            client2ResidentStatus: !residentStatusValid,
            client2CreditStatus: !creditStatusValid,
            client2HomeStatus: !homeStatusValid,
            client2Address1: !address1Valid,
            client2StartDate1: !startDate1Valid,
            client2Address2: !address2Valid,
            client2StartDate2: !startDate2Valid,
            client2Address3: !address3Valid,
            client2StartDate3: !startDate3Valid,
            client2SalaryWages: !salaryWagesValid,
            client2SalaryWagesIncome: !salaryWagesIncomeValid,
            client2SalaryWagesFrequency: !salaryWagesFrequencyValid,
            client2FamilyAllowance: !familyAllowanceValid,
            client2FamilyAllowanceFrequency: !familyAllowanceFrequencyValid,
            client2DividendIncome: !dividendIncomeValid,
            client2DividendIncomeFrequency: !dividendIncomeFrequencyValid,
            client2CompanyNetProfit: !companyNetProfitValid,
            client2CompanyNetProfitFrequency: !companyNetProfitFrequencyValid,
            client2Employment1CompanyName: !employment1CompanyNameValid,
            client2Employment1Role: !employment1RoleValid,
            client2Employment1StartDate: !employment1StartDateValid,
            client2Employment2CompanyName: !employment2CompanyNameValid,
            client2Employment2Role: !employment2RoleValid,
            client2Employment2StartDate: !employment2StartDateValid,
            client2Employment3CompanyName: !employment3CompanyNameValid,
            client2Employment3Role: !employment3RoleValid,
            client2Employment3StartDate: !employment3StartDateValid,
        });

        // If form is valid and isChecked is false, proceed
        // if (isValid) {
        const formattedData = formatClient2Data(formData);
        dispatch(
            updateFormData({
              formName: "client2Details",
              formData: formattedData,
            })
          );
        if (clientId != 0) {
            insertUpdateClient(formattedData);
        }
    };



    const handleValueChange = (name: string, value: string | Date | null) => {
        setFormData((prevData: any) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleErrorChange = (name: string, error: boolean) => {
        setFormErrors((prevErrors) => ({
            ...prevErrors,
            [name]: error,
        }));
    };

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsChecked(event.target.checked);
    };

    const splitDropdownValues = (dropdownValues: string) => {
        return dropdownValues ? dropdownValues.split(',').map(value => value.trim()) : [];
    };

    return (
        <Form onSubmit={handleSubmit} style={{
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            padding: '30px',
            backgroundColor: '#fff',
        }}>
            <Row className='g-3'>
                <Col xs={12} className='mb-4 text-left'>
                    <H3 className='f-w-900 heading-color'>Client 2 - Details</H3>
                </Col>
                
                {/* Add Submit Buttons Here */}
                <Col xs={12} className="text-end mt-4">
                    <Btn color="primary" className='me-2' onClick={() => activeCallBack(1)} style={{ fontSize: '18px' }}>{Previous}</Btn>
                    <Button disabled={isInsertUpdateClientPending} type="submit" color='success' style={{ fontSize: '18px' }}>
                        {isInsertUpdateClientPending ? "Loading . . ." : Continue}
                    </Button>
                </Col>

                <Row>
                    <Col className='mb-3'>
                        <FormGroup check className="custom-checkbox text-left">
                            {/* <Label check className="custom-label"> */}
                            <Input
                                type="checkbox"
                                checked={isChecked}
                                onChange={handleCheckboxChange}
                                className="custom-checkbox-input"
                            />
                            {' '}
                            <H3 className='f-w-900 heading-color'>There is no Client 2</H3>
                            {/* </Label> */}
                        </FormGroup>
                    </Col>
                </Row>
                <Row className="gx-2">
                    {/* First Name Field */}
                    <Col sm={10} className='sm-row' >
                        <TextField
                            label="First Name"
                            type="text"
                            name="client2FirstName"
                            value={formData.client2FirstName}
                            setValue={handleValueChange}
                            placeholder="Enter your first name"
                            // required={true}
                            disabled={isChecked}
                            // setError={handleErrorChange}
                            errorMessage="First Name is required"
                            // error={formErrors.client2FirstName}
                            design='flex'
                            passCol='col-5'
                            maxChars={30}
                            tabIndex={1}
                        />
                    </Col>

                    {/* Last Name Field */}
                    <Col sm={10} className='sm-row' >
                        <TextField
                            label="Last Name"
                            type="text"
                            name="client2LastName"
                            value={formData.client2LastName}
                            setValue={handleValueChange}
                            placeholder="Enter your last name"
                            // required={true}
                            disabled={isChecked}
                            // setError={handleErrorChange}
                            errorMessage="Last Name is required"
                            // error={formErrors.client2LastName}
                            design='flex'
                            passCol='col-5'
                            maxChars={30}
                            tabIndex={2}
                        />
                    </Col>

                    {/* Mobile Field */}
                    <Col sm={10} className='sm-row' >
                        <MobileField
                            label="Mobile Number"
                            mobileField="client2Mobile"
                            value={formData.client2Mobile}
                            setValue={(field, value) => handleValueChange(field, value)}
                            placeholder="0000 000 000"
                            // errorMessage="Invalid mobile number"
                            // error={formErrors.client2Mobile}
                            // required
                            design="flex"
                            passCol="col-3"
                            disabled={isChecked}
                            maxLength={18} // 12 digits for 0000 0000 0000 format
                            // setError={handleErrorChange}
                            tabIndex={3}
                        />
                    </Col>

                    {/* Email Field */}
                    <Col sm={10} className='sm-row' >
                        <TextField
                            label="Email"
                            type="text"
                            name="client2Email"
                            value={formData.client2Email}
                            setValue={handleValueChange}
                            placeholder="Enter your email"
                            // required={true}
                            disabled={isChecked}
                            // setError={handleErrorChange}
                            errorMessage="Email is required"
                            // error={formErrors.client2Email}
                            design='flex'
                            passCol='col-6'
                            maxChars={40}
                            tabIndex={4}
                        />
                    </Col>

                    {/* Gender Dropdown */}
                    <Col sm={10} className='sm-row' >
                        <Dropdown
                            label="Gender"
                            name="client2Gender"
                            value={formData.client2Gender}
                            setValue={handleValueChange}
                            options={splitDropdownValues(clientFactFindData ? clientFactFindData[0].dropDownValues : '')}
                            // required={true}
                            disabled={isChecked}
                            // errorMessage="Please select a gender"
                            // error={formErrors.client2Gender}
                            // setError={handleErrorChange}
                            design='flex'
                            passCol='col-3'
                            tabIndex={5}

                        />
                    </Col>

                    {/* Date of Birth DatePicker */}
                    <Col sm={10} className='sm-row' >
                        <DatePicker
                            label="Date of Birth"
                            name="client2Dob"
                            value={formData.client2Dob}
                            setValue={handleValueChange}
                            // required={true}
                            disabled={isChecked}
                            errorMessage="Date of Birth is required"
                            // error={formErrors.client2Dob}
                            // setError={handleErrorChange}
                            design='flex'
                            passCol='col-3'
                            tabIndex={6}
                        />
                    </Col>

                    {/* Marital Status Dropdown */}
                    <Col sm={10} className='sm-row' >
                        <Dropdown
                            label="Marital Status"
                            name="client2MaritalStatus"
                            value={formData.client2MaritalStatus}
                            setValue={handleValueChange}
                            options={splitDropdownValues(clientFactFindData ? clientFactFindData[1].dropDownValues : '')}
                            disabled={isChecked}
                            // errorMessage="Please select a marital status"
                            // error={formErrors.client2MaritalStatus}
                            // setError={handleErrorChange}
                            design='flex'
                            passCol='col-3'
                            tabIndex={7}
                        />
                    </Col>

                    {/* Resident Status Dropdown */}
                    <Col sm={10} className='sm-row' >
                        <Dropdown
                            label="Resident Status"
                            name="client2ResidentStatus"
                            value={formData.client2ResidentStatus}
                            setValue={handleValueChange}
                            options={splitDropdownValues(clientFactFindData ? clientFactFindData[2].dropDownValues : '')}
                            // required={true}
                            disabled={isChecked}
                            // errorMessage="Please select a resident status"
                            // error={formErrors.client2ResidentStatus}
                            // setError={handleErrorChange}
                            design='flex'
                            passCol='col-3'
                            tabIndex={8} />
                    </Col>

                    {/* Credit Status Dropdown */}
                    <Col sm={10} className='sm-row' >
                        <Dropdown
                            label="Credit Status"
                            name="client2CreditStatus"
                            value={formData.client2CreditStatus}
                            setValue={handleValueChange}
                            options={splitDropdownValues(clientFactFindData ? clientFactFindData[3].dropDownValues : '')}
                            // required={true}
                            disabled={isChecked}
                            // errorMessage="Please select a credit status"
                            // error={formErrors.client2CreditStatus}
                            // setError={handleErrorChange}
                            design='flex'
                            passCol='col-3'
                            tabIndex={9} />
                    </Col>

                    {/* Home Status Dropdown */}
                    <Col sm={10} className='sm-row' >
                        <Dropdown
                            label="Home Status"
                            name="client2HomeStatus"
                            value={formData.client2HomeStatus}
                            setValue={handleValueChange}
                            options={splitDropdownValues(clientFactFindData ? clientFactFindData[8].dropDownValues : '')}
                            // required={true}
                            disabled={isChecked}
                            // errorMessage="Please select a home status"
                            // error={formErrors.client2HomeStatus}
                            // setError={handleErrorChange}
                            design='flex'
                            passCol='col-3'
                            tabIndex={10} />
                    </Col>

                    <Col xs={12} className="my-4">
                        {/* Address History Section */}
                        <H3 className="f-w-900 heading-color mt-2 text-left">Address History</H3>
                        <Row className="gx-2 my-4">
                            <Col xs={12} md={7}>
                                <H4 className="heading-color f-w-700 mb-3 text-left">Home Address - we need 3 years history</H4>

                                {/* Address Inputs */}
                                <TextField
                                    type="text"
                                    name="client2Address1"
                                    value={formData.client2Address1}
                                    setValue={handleValueChange}
                                    placeholder="Enter address"
                                    // required
                                    disabled={isChecked}
                                    // error={formErrors.client2Address1}
                                    enableAddressFinder={true}
                                    errorMessage="Address is required"
                                    // setError={handleErrorChange}
                                    maxChars={60}
                                    tabIndex={11}
                                />
                                <TextField
                                    type="text"
                                    name="client2Address2"
                                    value={formData.client2Address2}
                                    setValue={handleValueChange}
                                    placeholder="Enter address"
                                    // required
                                    disabled={isChecked}
                                    enableAddressFinder={true}
                                    maxChars={60}
                                    tabIndex={13}

                                />
                                <TextField
                                    type="text"
                                    name="client2Address3"
                                    value={formData.client2Address3}
                                    setValue={handleValueChange}
                                    placeholder="Enter address"
                                    // required
                                    disabled={isChecked}
                                    enableAddressFinder={true}
                                    maxChars={60}
                                    tabIndex={15}
                                />
                            </Col>
                            <Col xs={12} md={2}>
                                <H4 className="heading-color f-w-700 mb-3 text-left">Start Date</H4>
                                <DatePicker
                                    name="client2StartDate1"
                                    value={formData.client2StartDate1}
                                    setValue={handleValueChange}
                                    disabled={isChecked}
                                    // error={formErrors.client2StartDate1}
                                    errorMessage="Start Date is required"
                                    // setError={handleErrorChange}
                                    label=""
                                    tabIndex={12}
                                />
                                <DatePicker
                                    name="client2StartDate2"
                                    value={formData.client2StartDate2}
                                    setValue={handleValueChange}
                                    disabled={isChecked}
                                    label=""
                                    tabIndex={14}
                                />
                                <DatePicker
                                    name="client2StartDate3"
                                    value={formData.client2StartDate3}
                                    setValue={handleValueChange}
                                    disabled={isChecked}
                                    label=""
                                    tabIndex={16}
                                />
                            </Col>
                        </Row>
                    </Col>

                    <Col xs={12} className="mb-4">
                        <H3 className="f-w-900 heading-color mt-2 text-left">Employment</H3>
                        <Col sm={12} className='sm-row mt-4' >
                            <Dropdown
                                label="Income Type"
                                name="client2SalaryWages"
                                value={formData.client2SalaryWages}
                                setValue={handleValueChange}
                                options={splitDropdownValues(clientFactFindData ? clientFactFindData[4].dropDownValues : '')}
                                // required={true}
                                disabled={isChecked}
                                // setError={handleErrorChange}
                                // errorMessage="Please select income type"
                                // error={formErrors.client2SalaryWages}
                                passCol='col-3'
                                tabIndex={17}
                                design='flex'
                            />
                        </Col>

                        {/* Income Type Section */}
                        <section>
                            <Row>
                                {/* First Column: Income Type */}
                                <Col xs={12} md={3}>
                                    <H4 className="heading-color f-w-700 text-left">Income Type</H4>
                                </Col>

                                {/* Second Column: Income $ */}
                                <Col xs={12} md={2}>
                                    <H4 className="heading-color f-w-700 text-left">Income $</H4>
                                </Col>

                                {/* Third Column: Frequency */}
                                <Col xs={12} md={2}>
                                    <H4 className="heading-color f-w-700 text-left">Frequency</H4>
                                </Col>
                            </Row>

                            <Row className="align-items-center mt-2">
                                {/* Salary / Wages */}
                                <Col xs={12} md={3}>
                                    <H5 style={{ fontSize: '14px' }} className="mb-3">
                                        Salary / Wages
                                    </H5>
                                </Col>
                                <Col xs={12} md={2}>
                                    <DollarInput
                                        name="client2SalaryWagesIncome"
                                        value={formData.client2SalaryWagesIncome}
                                        setValue={handleValueChange}
                                        placeholder="Enter amount"
                                        comma={true}
                                        className="mb-0"
                                        limit={9}
                                        disabled={isChecked}
                                        required
                                        tabIndex={20}
                                    />
                                </Col>
                                <Col xs={12} md={2}>
                                    <Dropdown
                                        label=""
                                        name="client2SalaryWagesFrequency"
                                        value={formData.client2SalaryWagesFrequency}
                                        setValue={handleValueChange}
                                        disabled={isChecked}
                                        options={splitDropdownValues(clientFactFindData ? clientFactFindData[11].dropDownValues : '')}
                                        required
                                        tabIndex={21}
                                    />
                                </Col>
                            </Row>
                            <Row className="align-items-center">
                                {/* Family Allowance */}
                                <Col xs={12} md={3} className="mb-3">
                                    <span style={{ fontSize: '14px' }}>Family Allowance</span>
                                </Col>
                                <Col xs={12} md={2}>
                                    <DollarInput
                                        name="client2FamilyAllowance"
                                        value={formData.client2FamilyAllowance}
                                        setValue={handleValueChange}
                                        placeholder="Enter amount"
                                        comma={true}
                                        limit={9}
                                        disabled={isChecked}
                                        required
                                        tabIndex={18}
                                    />
                                </Col>
                                <Col xs={12} md={2}>
                                    <Dropdown
                                        label=""
                                        name="client2FamilyAllowanceFrequency"
                                        value={formData.client2FamilyAllowanceFrequency}
                                        setValue={handleValueChange}
                                        disabled={isChecked}
                                        options={splitDropdownValues(clientFactFindData ? clientFactFindData[11].dropDownValues : '')}
                                        required
                                        tabIndex={19}
                                    />
                                </Col>
                            </Row>


                            <Row className="align-items-center">
                                {/* Dividend Income */}
                                <Col xs={12} md={3} className="mb-3">
                                    <H5 style={{ fontSize: '14px' }}>Dividend Income</H5>
                                </Col>
                                <Col xs={12} md={2}>
                                    <DollarInput
                                        name="client2DividendIncome"
                                        value={formData.client2DividendIncome}
                                        setValue={handleValueChange}
                                        placeholder="Enter amount"
                                        comma={true}
                                        limit={9}
                                        disabled={isChecked}
                                        required
                                        tabIndex={22}
                                    />
                                </Col>
                                <Col xs={12} md={2}>
                                    <Dropdown
                                        label=""
                                        name="client2DividendIncomeFrequency"
                                        value={formData.client2DividendIncomeFrequency}
                                        setValue={handleValueChange}
                                        disabled={isChecked}
                                        options={splitDropdownValues(clientFactFindData ? clientFactFindData[11].dropDownValues : '')}
                                        required
                                        tabIndex={23}
                                    />
                                </Col>
                            </Row>

                            <Row className="align-items-center">
                                {/* Company Net Profit */}
                                <Col xs={12} md={3} className="mb-3">
                                    <H5 style={{ fontSize: '14px' }}>Company Net Profit</H5>
                                </Col>
                                <Col xs={12} md={2}>
                                    <DollarInput
                                        name="client2CompanyNetProfit"
                                        value={formData.client2CompanyNetProfit}
                                        setValue={handleValueChange}
                                        placeholder="Enter amount"
                                        comma={true}
                                        limit={9}
                                        disabled={isChecked}
                                        required
                                        tabIndex={24}
                                    />
                                </Col>
                                <Col xs={12} md={2}>
                                    <Dropdown
                                        label=""
                                        name="client2CompanyNetProfitFrequency"
                                        value={formData.client2CompanyNetProfitFrequency}
                                        setValue={handleValueChange}
                                        disabled={isChecked}
                                        options={splitDropdownValues(clientFactFindData ? clientFactFindData[11].dropDownValues : '')}
                                        required
                                        tabIndex={25}
                                    />
                                </Col>
                            </Row>
                        </section>
                        {/* Employment History Section */}
                        <H3 className="f-w-900 heading-color mt-4 text-left">Employment History</H3>
                        <H4 className="heading-color f-w-700 mt-2 mb-4 text-left">
                            Home Address - we need 3 years history
                        </H4>

                        <Row className="gx-2 mt-5">
                            {/* First Column: Company Name */}
                            <Col xs={12} md={6}>
                                <H4 className="heading-color f-w-700 mb-3 text-left">Employer Name</H4>
                                {[1, 2, 3].map((index) => (
                                    <TextField
                                        key={`client2CompanyName${index}`}
                                        type="text"
                                        name={`client2Employment${index}CompanyName`}
                                        value={formData[`client2Employment${index}CompanyName`]}
                                        setValue={handleValueChange}
                                        placeholder="Employer Name"
                                        // required
                                        disabled={isChecked}
                                        maxChars={60}
                                        tabIndex={index === 1 ? 26 : index === 2 ? 29 : 32}  // Specific tabIndex values: 26, 29, 32
                                    />
                                ))}
                            </Col>

                            {/* Second Column: Role */}
                            <Col xs={12} md={3}>
                                <H4 className="heading-color f-w-700 mb-3 text-left">Role</H4>
                                {[1, 2, 3].map((index) => (
                                    <TextField
                                        key={`client2Role${index}`}
                                        type="text"
                                        name={`client2Employment${index}Role`}
                                        value={formData[`client2Employment${index}Role`]}
                                        setValue={handleValueChange}
                                        placeholder="Role"
                                        // required
                                        disabled={isChecked}
                                        tabIndex={index === 1 ? 27 : index === 2 ? 30 : 33}  // Specific tabIndex values: 27, 30, 33
                                    />
                                ))}
                            </Col>

                            {/* Third Column: Start Date */}
                            <Col xs={12} md={2}>
                                <H4 className="heading-color f-w-700 mb-3 text-left">Start Date</H4>
                                {[1, 2, 3].map((index) => (
                                    <DatePicker
                                        key={`client2StartDate${index}`}
                                        name={`client2Employment${index}StartDate`}
                                        value={formData[`client2Employment${index}StartDate`]}
                                        setValue={handleValueChange}
                                        label=""
                                        disabled={isChecked}
                                        tabIndex={index === 1 ? 28 : index === 2 ? 31 : 34}  // Specific tabIndex values: 28, 31, 34
                                    />
                                ))}
                            </Col>
                        </Row>
                    </Col>
                 
                </Row>
            </Row>
        </Form>
    );
}